/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowvariants2Inputs */

const en_aiflowvariants2 = /** @type {(inputs: Aiflowvariants2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here are four directions. Tap one and refine it, or take it right away.`)
};

const de_aiflowvariants2 = /** @type {(inputs: Aiflowvariants2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier sind vier Richtungen. Tipp eine an und verfeinere sie, oder nimm sie direkt.`)
};

/**
* | output |
* | --- |
* | "Here are four directions. Tap one and refine it, or take it right away." |
*
* @param {Aiflowvariants2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowvariants2 = /** @type {((inputs?: Aiflowvariants2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowvariants2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowvariants2(inputs)
	return de_aiflowvariants2(inputs)
});
export { aiflowvariants2 as "aiFlowVariants" }